module.exports = __webpack_public_path__ + "img/ss_pink-01.a16d36de.jpg";